import { render, staticRenderFns } from "./ItemSubCodeDialog.vue?vue&type=template&id=1877ffde"
import script from "./ItemSubCodeDialog.vue?vue&type=script&lang=js"
export * from "./ItemSubCodeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports